var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../../api/axios";
import { AccountRoutesType } from "../../Shared/components/Navigation/navigationUtils";
import { LoginRegisterText } from "../LoginRegister-types";
import { updateCartCustomer } from "../../Account/utils/requests";
import logRocketLauncher from "../../Shared/utils/logRocketLauncher";
export const loginCustomer = (email, password, rememberMe) => {
    return axiosPrivate.post("/Login", { Email: email, Password: password, RememberMe: rememberMe });
};
export const forgotPassword = (email) => {
    return axiosPrivate.post("/ForgotPassword", { email: email });
};
/**
 * Track customer login on Klaviyo
 * @param companyUsesKlaviyo
 * @param createKlaviyoEvent
 */
export const loginEvent = (createKlaviyoEvent) => () => {
    createKlaviyoEvent("CompleteRegistration");
    //Klaviyo requires a customer so PageView must be tracked after logging in
    createKlaviyoEvent("PageView", {
        SelectedLocation: "Login",
    });
};
export const handleLoginFormSubmit = (setError, setLoading, navigate, location, loginEvent, setIsAuthenticated, isLogRocketEnabled) => (data) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    setLoading(true);
    const res = yield loginCustomer(data.email, data.password, data.rememberMe);
    if (res.data.success) {
        updateCartCustomer();
        if (isLogRocketEnabled === true) {
            logRocketLauncher.login();
        }
        loginEvent();
        setIsAuthenticated(true);
        localStorage.setItem("mt-customer", "true");
        const nextRoute = (_b = (_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.prevRoute) !== null && _b !== void 0 ? _b : AccountRoutesType.ORDERS;
        navigate(nextRoute, { state: Object.assign({}, location.state), replace: true });
    }
    if (!res.data.success) {
        setError("password", { message: res.data.responseMsg });
        setLoading(false);
    }
});
export const handleForgotPassword = (setError, setLoading, clearErrors, trigger, toast, email) => __awaiter(void 0, void 0, void 0, function* () {
    clearErrors("email");
    const triggerRes = yield trigger("email", { shouldFocus: true });
    if (email === "" || !triggerRes) {
        setError("email", { type: "validate", message: LoginRegisterText.FORGOT_PASSWORD_EMAIL_REQUIRED });
        return;
    }
    setLoading(true);
    const res = yield forgotPassword(email);
    toast.push(res.data.responseMsg, { variant: res.data.success ? "success" : "error" });
    setLoading(false);
});
